import { render, staticRenderFns } from "./settings-menu-child.vue?vue&type=template&id=d6b59ab4"
import script from "./settings-menu-child.vue?vue&type=script&lang=js"
export * from "./settings-menu-child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports